const firebaseConfigDev = {
  apiKey: "AIzaSyApeO8bNHSFgcCkdJsqewp5HupXPKK_wQw",
  authDomain: "rosemount-financial-solu-4f940.firebaseapp.com",
  projectId: "rosemount-financial-solu-4f940",
  storageBucket: "rosemount-financial-solu-4f940.appspot.com",
  messagingSenderId: "9919024994",
  appId: "1:9919024994:web:9b33d20b13cb543b94a63b",
  measurementId: "G-QQYKN93MYH",
};

export default firebaseConfigDev;
